import React from 'react';
import { uniqBy } from 'lodash-es';
import SpotSelectorItem from './item';
import { SearchIcon } from 'app/scripts/icons';

interface SpotSelectorItemsProps {
  searchedSpot: string;
  spots: Spot[];
  spotId: string;
  handleClose: () => void;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface Spot {
  id: string;
  name: string;
  type: string;
  networkId: string;
}

export const SpotSelectorItems: React.FC<SpotSelectorItemsProps> = ({
  searchedSpot,
  spots,
  spotId,
  handleClose,
  onSearchChange
}) => {
  const elements = uniqBy(spots, 'id')
    .filter(spot => spot.name.toLowerCase().includes(searchedSpot))
    .map(spot => {
      return (
        <SpotSelectorItem
          key={spot.id}
          isSelected={spotId === spot.id}
          spotName={spot.name}
          spotType={spot.type}
          spotId={spot.id}
          networkId={spot.networkId}
          closeSpotSelector={handleClose}
        />
      );
    });

  return (
    <div className="dropdown">
      <SearchIcon className="search-icon spots-dropdown-search-icon" />
      <input
        className="spots-dropdown-search"
        type="search"
        onChange={onSearchChange}
        placeholder={'Search site'}
      />
      <div className="spots-list">{elements}</div>
    </div>
  );
};
